import {
  fetchNotificationsServer,
  updateNotificationStateServer,
  markNotificationsAsSeenServer,
} from '@/actions/notifications';
import { NotificationState } from '@/actions/dtos/notification';
import { getUserAccessToken } from '@/utils/account/getUserAccessToken';

export const fetchNotifications = async (personId: string, page: number, size: number, state?: NotificationState) => {
  const userAccessToken = await getUserAccessToken();
  return fetchNotificationsServer(personId, state, page, size, userAccessToken);
};

export const updateNotificationState = async (notificationId: string, state: NotificationState) => {
  const userAccessToken = await getUserAccessToken();
  return updateNotificationStateServer(notificationId, state, userAccessToken);
};

export const markNotificationsAsSeen = async () => {
  const userAccessToken = await getUserAccessToken();
  return markNotificationsAsSeenServer(userAccessToken);
};
